/* Freedom Sale — hide client-injected app widgets that carry no stable class.
   The EMI line (GoKwik/Snapmint) and the free-gift bar mount after load, so
   they can only be found by text. Each match is tagged; freedom-palette.css
   hides the tag.

   SAFETY: the climb NEVER crosses an element that contains a button, form or
   input. An earlier version climbed blindly and swallowed the Add to Cart /
   Order Now buttons. If a candidate contains anything interactive we stop and
   hide only the text node's own element.

   Better long-term: switch the free-gift bar off in the app's own settings. */
(function () {
  var INTERACTIVE = 'button,form,input,select,textarea,[type="submit"],' +
                    '[name="add"],.btn,.product-single__add-to-cart,.shopify-payment-button';

  var RULES = [
    { cls: 'fs-emi-node',  row: 'fs-emi-row',
      re: /(\/\s*month)|(buy\s+on\s+emi)/i, maxLen: 90,  climb: 3 },
    { cls: 'fs-gift-node', row: 'fs-gift-row',
      re: /(get\s+free\s+gifts?\s+on\s+order)|(away\s+to\s+unlock)/i, maxLen: 420, climb: 4 }
  ];

  function safe(el) {
    return el && el.nodeType === 1 && !el.querySelector(INTERACTIVE) &&
           !el.matches(INTERACTIVE) && el !== document.body &&
           el.tagName !== 'MAIN' && el.tagName !== 'FORM';
  }

  function apply(root, rule) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var node, hit = false;
    while ((node = walker.nextNode())) {
      if (!rule.re.test(node.textContent || '')) continue;
      var el = node.parentElement;
      if (!el || el.classList.contains(rule.cls)) continue;
      if (!safe(el)) continue;                  /* never touch anything holding a control */
      el.classList.add(rule.cls);

      var row = el;
      for (var i = 0; i < rule.climb; i++) {
        var p = row.parentElement;
        if (!p || p === root) break;
        if (!safe(p)) break;                    /* stop before a container with a button */
        if ((p.textContent || '').length > rule.maxLen) break;
        row = p;
      }
      if (safe(row)) row.classList.add(rule.row);
      hit = true;
    }
    return hit;
  }

  function scan() {
    var scopes = document.querySelectorAll(
      '.grid-product__wrapper, [data-product-card], .price-container-wrapper,' +
      '.product-single, #ProductSection, .sticky_price_container, main');
    for (var r = 0; r < RULES.length; r++) {
      for (var i = 0; i < scopes.length; i++) apply(scopes[i], RULES[r]);
    }
  }

  function start() {
    scan();
    if (!window.MutationObserver) return;
    var mo = new MutationObserver(scan);
    mo.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { mo.disconnect(); }, 20000);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  window.addEventListener('load', scan);
})();
